import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { formatIdrFromUsd } from '../../utils/currency';

const ProductCard = ({ product }) => {
  const { id, name, price, images, isNew, isFeatured, inStock } = product;
  
  return (
    <div className="group relative bg-black border border-gray-800 overflow-hidden image-hover-zoom">
      {isNew && (
        <div className="absolute top-2 left-2 z-10 bg-primary text-dark text-xs font-bold px-2 py-1">
          New
        </div>
      )}
      
      {isFeatured && (
        <div className="absolute top-2 right-2 z-10 bg-secondary text-light text-xs font-bold px-2 py-1">
          Featured
        </div>
      )}
      
      <Link to={`/products/${id}`} className="block">
        <div className="relative aspect-square overflow-hidden">
          <img
            src={images[0]}
            alt={name}
            className="w-full h-full object-cover object-center"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/400x400/333/666?text=No+Image';
            }}
          />
          
          {!inStock && (
            <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
              <span className="bg-red-900 text-white px-4 py-2 font-bold uppercase tracking-wider transform -rotate-12">
                Sold Out
              </span>
            </div>
          )}
          
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-4">
            <Button 
              variant="primary" 
              size="sm"
              className="mb-4"
            >
              View Details
            </Button>
          </div>
        </div>
        
        <div className="p-4">
          <h3 className="font-serif text-lg font-medium text-light mb-2">{name}</h3>
          <div className="flex justify-between items-center">
            <span className="text-lg font-bold text-primary">{formatIdrFromUsd(price)}</span>
            {!inStock && (
              <span className="text-sm text-red-400">Out of Stock</span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
